import styled from 'styled-components'
import { BREAK_POINT_SM } from '@CSSVars/variables'

export const _ChildrenContainer = styled.div`
  padding: 0 12px 12px 12px;
  background: white;
  border-radius: 10px;
  > span {
    display: inline-block;
    margin: 6px;
  }
  @media screen and (max-width: ${BREAK_POINT_SM}) {
    padding-top: 10px;
    display: flex;
    flex-wrap: wrap;
  }
`
